import ArrowUp from './ArrowUp'
import styles from './FactNumbers.module.scss'

const FactNumbers = ({ children }) => <div className={styles.factNumbers}>{children}</div>

const Item = ({ Icon, value, delta, label, width = 50, height = 50 }) => (
  <div className={styles.item}>
    <div>{Icon && <Icon className={styles.icon} style={{ width, height }} />}</div>
    <div>
      <div className={styles.description}>{label}</div>
      <div className={styles.values}>
        <span className={styles.bigNumber}>{value}</span>
        {typeof delta !== 'undefined' && (
          <span className={styles.delta}>
            <ArrowUp /> +{delta}
          </span>
        )}
      </div>
    </div>
  </div>
)

FactNumbers.Item = Item

export default FactNumbers
